import { render, staticRenderFns } from "./ResetPasswordPage.vue?vue&type=template&id=48e8d01e"
import script from "./ResetPasswordPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResetPasswordPage.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports